import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 264 165"
      height={props.height}
      style={{verticalAlign: "middle", marginBottom: "3px"}}
    //   width={props.width}
    >
      <path
      fill={props.color ? props.color : "white"}
        d="M16192.5 2435.83h-246.7c-1.3.09-2.4.34-3.5.8a8.211 8.211 0 00-4.7 7.44v147.78c0 4.55 3.7 8.24 8.2 8.24h246.7c4.5 0 8.2-3.69 8.2-8.24v-147.78c0-2.88-1.5-5.42-3.7-6.89-1.4-.88-2.9-1.33-4.5-1.35zm-10.5 18.75l-107.6 90.93c-3.1 2.54-7.5 2.54-10.5 0l-107.6-90.93v126.76h225.7v-126.76zm-196.6 0l83.7 70.78 83.8-70.78h-167.5z"
        transform="translate(-15937.6 -2435.83)"
      ></path>
    </svg>
  );
}

export default Icon;
